import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useMsal } from '@azure/msal-react';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { isAuthenticated, isAdmin, loading } = useAuth();
  const { inProgress } = useMsal();

  if (loading || inProgress === 'login') {
    return (
      <div className="card" style={{ textAlign: 'center', padding: '3rem' }}>
        <h2>Loading...</h2>
        <p>Authenticating user...</p>
      </div>
    );
  }

  if (!isAuthenticated()) {
    return (
      <div className="card" style={{ textAlign: 'center', padding: '3rem' }}>
        <h2>Authentication Required</h2>
        <p>Please log in to access this page.</p>
      </div>
    );
  }

  if (adminOnly && !isAdmin()) {
    return (
      <div className="card" style={{ textAlign: 'center', padding: '3rem' }}>
        <h2>Access Denied</h2>
        <p>You do not have permission to access this page.</p>
        <p style={{ color: '#666', marginTop: '1rem' }}>
          This page requires administrator privileges.
        </p>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
